export default __webpack_public_path__ + "static/media/default.5f3fd8f1ebc65bbf02de3c09d46bed63.png";